export default {
  userProfile: {},
  userClaims: [],
  userNotificationperference: {},
  userAttributes: {},
  orgPreferences: { zipCodeKms: 32 },
};
